export default "__VITE_ASSET__GI0l4RMi__"